<template>
  <div class="selectionSummary">
    <header
      class="selectionSummaryHeader"
      v-if="isLastSegment || breakpoints.isDesktop"
    >
      <h2>{{ $t('shopping_lib.selection_summary') }}</h2>
    </header>
    <section class="selectionSummaryCards">
      <details
        v-for="(journey, key) in journeys"
        :key="`itin_selected_${key}`"
        :open="isLastSegment || breakpoints.isDesktop"
      >
        <summary>
          <h3 class="summaryTitle">
            <i class="fas fa-circle-check"></i>
            {{ getSummarySelectionTitle(journey) }}
          </h3>
          <i class="summaryIcon fas fa-angle-down"></i>
        </summary>

        <article class="selectionSummaryCard">
          <h3 class="selectionSummaryCard__title">
            <i class="fas fa-circle-check"></i>
            {{ getSummarySelectionTitle(journey) }}
          </h3>

          <span class="selectionSummary__badge">{{ journey.fare.name }}</span>

          <span
            class="selectionSummary__changeButton"
            @click="$emit('onChangeTrip', journey?.trip_segment)"
          >
            <i class="fas fa-ticket"></i>
            {{ $t('shopping_lib.change_flight') }}
          </span>

          <itinerary-card
            class="itinerary"
            :journey="journey"
            :key="`itin_selected_${journey?.trip_segment}`"
            :airportsInformation="airportsInformation"
          />
        </article>
      </details>
    </section>
  </div>
</template>
<script>
import ItineraryCard from './Itinerary/ItineraryCard.vue'
import { useResize } from '../helpers/useResize'
export default {
  name: 'SelectionSummary',
  components: {
    ItineraryCard,
  },
  props: {
    journeys: {
      required: true,
    },
    isLastSegment: null,
    airportsInformation: {
      required: false,
      type: Object,
    },
  },
  data() {
    return {
      breakpoints: null,
    }
  },
  beforeMount() {
    this.breakpoints = useResize()
  },
  methods: {
    getSummarySelectionTitle: function (journey) {
      const flight =
        journey.trip_segment === 1 ? 'outbound_flight' : 'return_flight'
      return this.$t(`shopping_lib.${flight}`)
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
.selectionSummary
  position: relative
  &Cards
    gap: 2rem
    display: flex
    flex-direction: column
  &Header
    margin-bottom: 2rem

// details > summary
.selectionSummaryCards
  display: grid
  gap: 1.5rem
  details
    position: relative
    padding-bottom: 1rem
    &:after
      content: ''
      width: 100%
      position: absolute
      bottom: 0
      border-bottom: solid 1px var(--color-overlay-20)
    summary
      display: flex
      justify-content: space-between
      margin-bottom: 1rem
      &::-webkit-details-marker
        display: none
      i.summaryIcon
        font-size: 1rem
        color: var(--color-primary)
        align-self: center
    .summaryTitle, .selectionSummaryCard__title
      font-weight: 700
      line-height: 1.75rem
      i
        color: var(--color-success)
        font-size: var(--font-size-md)
.selectionSummaryCards details[open]
  summary i.summaryIcon
    transform: rotate(180deg)
.selectionSummaryCard
  display: grid
  grid-template-columns: auto 1fr 1fr
  grid-template-areas: "fare . ." "card card card" ". button button"
  gap: 1rem
.selectionSummaryCard__title
  grid-area: flight
  margin: 0
  font-weight: 600
  display: none
.itinerary
  grid-area: card
.itinerary::v-deep
  .itineraryCard
    all: unset
    border-radius: var(--b-radius-md)
    border: 2px solid var(--color-overlay-10)
    border-top-width: 0.8rem
  .itineraryFooter__displayFares
    display: none
.selectionSummary__changeButton
  color: var(--color-primary)
  font-weight: 600
  font-size: var(--font-size-base)
.selectionSummary__changeButton
  grid-area: button
  justify-self: flex-end
  font-weight: 400
  display: flex
  align-items: center
  gap: .5rem
  cursor: pointer
  padding: 0px 12px
  border: 1px solid
  border-radius: .25rem
  max-width: fit-content
  height: 2.25rem
  align-self: flex-end
  color: var(--color-error)
  transition: 0.25s
  &:hover, &:focus
    box-shadow: inset 0 0 0 2em var(--color-error)
    color: var(--color-onPrimary)
.selectionSummaryCard__title i
  color: var(--color-success)
.selectionSummary__badge
  grid-area: fare
  justify-self: flex-start
  border: 1px solid
  background-color: var(--color-primary)
  color: var(--color-onPrimary)
  border-radius: 1rem
  max-height: 1.75rem
  min-width: 4rem
  font-size: var(--font-size-sm)
  font-weight: 700
  padding: 2px 12px

@media (min-width: 1024px)
  .itinerary::v-deep
    .itineraryCard
      border: 2px solid var(--color-overlay-10)
      border-left-width: 0.8rem
  .selectionSummary__changeButton
    font-size: var(--font-size-md)
  .selectionSummary__badge
    font-size: var(--font-size-base)
    align-self: center
  .selectionSummaryCard
    grid-template-columns: min-content auto auto
    grid-template-areas: "flight fare button" "card card card"
  .selectionSummaryCard__title
    display: inline-block
    min-width: max-content
    align-self: center
  .selectionSummaryCards details
    &:after
      all: unset
    summary
      display: none
  .selectionSummary__priceDetail
    display: none

@media (max-width: 418px)

  .selectionSummaryCards
    details
      summary
        margin-bottom: 0.25rem
 
  .selectionSummary
    &Header
      margin-bottom: 1rem
    h2, h3
      font-size: var(--font-size-md)

</style>
